import React from 'react'
import AppContext from 'AppContext'
import { env } from 'components/Helpers'

const FreePassV2 = (props) => {
  const token = window.localStorage.getItem('auth-token')

  const { operator: { id, name, locales } } = React.useContext(AppContext)

  // We may have to wait for AppContext to be available
  if (!id) {
    return (
      <div className='index free-pass' />
    )
  }

  // Must leave empty h1 there for element below not to be cropped...
  return (
    <div className='index free-pass'>
      {/* eslint-disable-next-line */}
    <h1></h1>

      <cl-free-passes
        apiUrl={`https://free-passes.${env()}.credlock.net/api`}
        mountPath={`/operators/${id}/free-passes`}
        operatorid={id}
        token={token}
        locales={locales}
        operatorname={name}
      />
    </div>
  )
}

export default FreePassV2
